import { render, staticRenderFns } from "./SalesAverageSource.vue?vue&type=template&id=1bb48fea&"
import script from "./SalesAverageSource.vue?vue&type=script&lang=js&"
export * from "./SalesAverageSource.vue?vue&type=script&lang=js&"
import style0 from "./SalesAverageSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports